import { View } from "react-native";
import { useReceiptOrder } from "../../ReceiptContext";
import { VendorMetadataBlockSettings } from "../../../../../../web-receipt-api/src/lib/validateReceiptStructure";
import { cssStyles } from "../ReceiptFooter/styles";
import { vendorEntriesByType } from "../../utils";

export type VendorMetadataBlockProps = {
  blockSettings: VendorMetadataBlockSettings & {
    useMonospace?: boolean;
  };
};

export function VendorMetadataBlock(props: VendorMetadataBlockProps) {
  const order = useReceiptOrder();
  const { metadataType, useMonospace = false } = props.blockSettings;

  const entries = vendorEntriesByType(order.vendorMetadata, metadataType);

  if (entries.length === 0) {
    return null;
  }

  return (
    <View>
      <div
        style={{ padding: "8px" }}
        data-vendors={entries.map((entry) => entry.vendor).join(",")}
      >
        <div
          style={{
            ...cssStyles.extraText,
            ...(useMonospace && { fontFamily: "monospace" }),
          }}
        >
          {entries.map((entry) => entry.value).join(", ")}
        </div>
      </div>
    </View>
  );
}
